import React, { useMemo } from "react";

import cn from "./Button.module.scss";

interface IProps {
	className?: string;
	title: string;
	type?: "button" | "submit" | "reset" | undefined;
	onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
	variant?: "primary" | "cancel";
	disabled?: boolean;
}

export const Button = ({ title, className = "", type, onClick, variant, disabled }: IProps): JSX.Element => {
	const onClickHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
		event.preventDefault();
		if (onClick) {
			onClick(event);
		}
	};

	const variantClass: string = useMemo(() => {
		switch (variant) {
			case "primary": {
				return cn.primary;
			}
			case "cancel": {
				return cn.cancel;
			}
			default: {
				return cn.button;
			}
		}
	}, [variant]);

	return (<button type={type} disabled={disabled} className={`${variantClass} ${className}`} onClick={onClickHandler}>{title}</button>);
};
